export default __webpack_public_path__ + "static/media/graphic.3ae15f11.png";